import { z } from "zod";

import { vrsSchema } from "@schemas/sign";

/**
 * schemas
 */

export const authLoginRequestSchema = z.object({
  siwe: z.string(),
  signature: vrsSchema,
});
export type AuthLoginRequest = z.infer<typeof authLoginRequestSchema>;

export const authLoginResponseSchema = z.object({
  authorization: z.string(),
});
export type AuthLoginResponse = z.infer<typeof authLoginResponseSchema>;

export const authLogoutResponseSchema = z.any();
export type AuthLogoutResponse = z.infer<typeof authLogoutResponseSchema>;
